import React from "react";
import { webSoftwareServiceData } from "../../data/services-data";
import SEO from "../../components/SEO";
import seoData from "../../data/seoData";
const ServiceDetailsInner = React.lazy(() =>
  import("../../components/ServiceDetailsInner")
);

const WebSoftwareServiceDetailPage = () => {
  const webData = webSoftwareServiceData;
  return (
    <>
      <SEO {...seoData.webSoftware} />
      <ServiceDetailsInner data={webData} />
    </>
  );
};

export default WebSoftwareServiceDetailPage;
